export interface CompanyStateI {
  locations: any[];
  users: any[];
  clients: any[];
  carePartners: any[];
  careManagerActivities: any[];
  applicants: any[];
  awardTypes: any[];
  deactivationReasons: any[];
  lostClientReasons: any[];
  prospectlostClientReason: any[];
  applicantStages: any[];
  referralPartner: any[];
  companies: any[];
  prospect: any[];
  milestones: any[];
  ratings: any[];
  companyRatings: any[];
  priorityIndexes: any[];
  priorityIndexesCP: any[];
  activityTypes: any[];
  companyTypes: any[];
  applicantsActivity: any[];
  applicantSources: any[];
  leadSources: any[];
  referralActivityTypes: any[];
  applicantActivityTypeCategory: any[];
  activityCategoryManagement: any[];
  prospectActivityCategory: any[];
  referralPartnersActivityCategory: any[];
  authorizationStages: any[];
  reAuthorizationStages: any[];
  authorizationTypes: any[];
  authorizations: any[];
  requestedStages: any[];
  tags: any[];
  tagCategory: any[];
  prospectStages: any[];
  contactTypes: any[];
  contactRelationships: any[];
  disciplinarySteps: any[];
  disciplinaryCategories: any[];
  disciplinaryAcks: any[];
  disciplinaryAttendanceTypes: any[];
  applicantThreshold: any[];

}

const companyInitialState: CompanyStateI = {
  locations: [],
  users: [],
  clients: [],
  carePartners: [],
  careManagerActivities: [],
  applicants: [],
  awardTypes: [],
  deactivationReasons: [],
  lostClientReasons: [],
  prospectlostClientReason: [],
  applicantStages: [],
  referralPartner: [],
  companies: [],
  prospect: [],
  milestones: [],
  ratings: [],
  companyRatings: [],
  priorityIndexes: [],
  priorityIndexesCP: [],
  activityTypes: [],
  companyTypes: [],
  applicantsActivity: [],
  applicantSources: [],
  leadSources: [],
  referralActivityTypes: [],
  applicantActivityTypeCategory: [],
  activityCategoryManagement: [],
  prospectActivityCategory: [],
  referralPartnersActivityCategory: [],
  authorizationStages: [],
  authorizationTypes: [],
  reAuthorizationStages: [],
  authorizations: [],
  requestedStages: [],
  tags: [],
  tagCategory: [],
  prospectStages: [],
  contactTypes: [],
  contactRelationships: [],
  disciplinarySteps: [],
  disciplinaryCategories: [],
  disciplinaryAcks: [],
  disciplinaryAttendanceTypes: [],
  applicantThreshold: []
};

export { companyInitialState };
